import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import { Eye } from 'react-feather';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const POItemReleaseTable = ({ data, onViewShipments }) => {


  const columns = [
    {
      title: 'Item Name',
      dataIndex: 'itemName',
      key: 'itemName',
    },
    {
      title: 'Request Date',
      dataIndex: 'requestDate',
      key: 'requestDate',
    },
    {
      title: 'Promise Date',
      dataIndex: 'promiseDate',
      key: 'promiseDate',
    },
    {
      title: 'Requested Quantity',
      dataIndex: 'requestedQuantity',
      key: 'requestedQuantity',
    },
    {
      title: 'Comment',
      dataIndex: 'comment',
      key: 'comment',
    },
    {
      title: 'View Shipments',
      key: 'viewShipments',
      render: (_, record) => (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id={`view-shipments-tooltip-${record.poItemReleaseID}`}>View Shipments</Tooltip>}
        >
          <button
            className="btn btn-light btn-sm d-flex align-items-center"
            style={{ border: '1px solid #ddd' }}
            onClick={() => onViewShipments && onViewShipments(record.poItemReleaseID)}
          >
            <Eye size={16} />
          </button>
        </OverlayTrigger>
      ),
    },
  ];

  return <Table columns={columns} dataSource={data} rowKey="poItemReleaseID" pagination={false} />;
};

POItemReleaseTable.propTypes = {
  data: PropTypes.array,
  onViewShipments: PropTypes.func,
};

export default POItemReleaseTable; 